module.exports = __webpack_public_path__ + "img/puzzle_5.13a63e84.png";